import React from "react";
import { PDFViewer } from "@react-pdf/renderer";
import ServiceSheetDocument, { ServiceSheetDocumentProps } from "./ServiceSheetDocument";

const ServiceSheetPDFViewer: React.FC<ServiceSheetDocumentProps> = ({
    serviceSheet,
    qrCodeBase64,
    pageSize,
}) => {
    return (
        <PDFViewer style={{ width: "100%", height: "100vh" }} showToolbar={false}>
            <ServiceSheetDocument
                serviceSheet={serviceSheet}
                qrCodeBase64={qrCodeBase64}
                pageSize={pageSize}
            />
        </PDFViewer>
    );
};

export default ServiceSheetPDFViewer;
